import _toConsumableArray from "/home/metagest/public_html/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/metagest/public_html/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/metagest/public_html/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/metagest/public_html/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { _ as _async_to_generator } from './cc-BU0zEyYq.js';
import { useState, useReducer, useRef, useCallback, useEffect } from 'react';
import debounce from 'lodash.debounce';
var NativeSpeechRecognition = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition);
var isNative = function isNative(SpeechRecognition) {
  return SpeechRecognition === NativeSpeechRecognition;
};
var isAndroid = function isAndroid() {
  return /(android)/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
};
var concatTranscripts = function concatTranscripts() {
  for (var _len = arguments.length, transcriptParts = new Array(_len), _key = 0; _key < _len; _key++) {
    transcriptParts[_key] = arguments[_key];
  }
  return transcriptParts.map(function (t) {
    return t.trim();
  }).join(" ").trim();
};
// The command matching code is a modified version of Backbone.Router by Jeremy Ashkenas, under the MIT license.
var optionalParam = /\s*\((.*?)\)\s*/g;
var optionalRegex = /(\(\?:[^)]+\))\?/g;
var namedParam = /(\(\?)?:\w+/g;
var splatParam = /\*/g;
var escapeRegExp = /[-{}[\]+?.,\\^$|#]/g;
var commandToRegExp = function commandToRegExp(command) {
  if (command instanceof RegExp) {
    return new RegExp(command.source, "i");
  }
  command = command.replace(escapeRegExp, "\\$&").replace(optionalParam, "(?:$1)?").replace(namedParam, function (match, optional) {
    return optional ? match : "([^\\s]+)";
  }).replace(splatParam, "(.*?)").replace(optionalRegex, "\\s*$1?\\s*");
  return new RegExp("^" + command + "$", "i");
};
// this is from https://github.com/aceakash/string-similarity
var compareTwoStringsUsingDiceCoefficient = function compareTwoStringsUsingDiceCoefficient(first, second) {
  first = first.replace(/\s+/g, "").toLowerCase();
  second = second.replace(/\s+/g, "").toLowerCase();
  if (!first.length && !second.length) return 1; // if both are empty strings
  if (!first.length || !second.length) return 0; // if only one is empty string
  if (first === second) return 1; // identical
  if (first.length === 1 && second.length === 1) return 0; // both are 1-letter strings
  if (first.length < 2 || second.length < 2) return 0; // if either is a 1-letter string
  var firstBigrams = new Map();
  for (var i = 0; i < first.length - 1; i++) {
    var bigram = first.substring(i, i + 2);
    var count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
    firstBigrams.set(bigram, count);
  }
  var intersectionSize = 0;
  for (var _i = 0; _i < second.length - 1; _i++) {
    var _bigram = second.substring(_i, _i + 2);
    var _count = firstBigrams.has(_bigram) ? firstBigrams.get(_bigram) : 0;
    if (_count > 0) {
      firstBigrams.set(_bigram, _count - 1);
      intersectionSize++;
    }
  }
  return 2.0 * intersectionSize / (first.length + second.length - 2);
};
var browserSupportsPolyfills = function browserSupportsPolyfills() {
  return typeof window !== "undefined" && window.navigator !== undefined && window.navigator.mediaDevices !== undefined && window.navigator.mediaDevices.getUserMedia !== undefined && (window.AudioContext !== undefined || window.webkitAudioContext !== undefined);
};
var RecognitionManager = /*#__PURE__*/function () {
  function RecognitionManager(SpeechRecognition) {
    _classCallCheck(this, RecognitionManager);
    this.recognition = null;
    this.pauseAfterDisconnect = false;
    this.interimTranscript = "";
    this.finalTranscript = "";
    this.listening = false;
    this.isMicrophoneAvailable = true;
    this.subscribers = {};
    this.onStopListening = function () {};
    this.previousResultWasFinalOnly = false;
    this.resetTranscript = this.resetTranscript.bind(this);
    this.startListening = this.startListening.bind(this);
    this.stopListening = this.stopListening.bind(this);
    this.abortListening = this.abortListening.bind(this);
    this.setSpeechRecognition = this.setSpeechRecognition.bind(this);
    this.disableRecognition = this.disableRecognition.bind(this);
    this.setSpeechRecognition(SpeechRecognition);
    if (isAndroid()) {
      this.updateFinalTranscript = debounce(this.updateFinalTranscript, 250, {
        leading: true
      });
    }
  }
  _createClass(RecognitionManager, [{
    key: "setSpeechRecognition",
    value: function setSpeechRecognition(SpeechRecognition) {
      var browserSupportsRecogniser = !!SpeechRecognition && (isNative(SpeechRecognition) || browserSupportsPolyfills());
      if (browserSupportsRecogniser) {
        this.disableRecognition();
        this.recognition = new SpeechRecognition();
        this.recognition.continuous = false;
        this.recognition.interimResults = true;
        this.recognition.onresult = this.updateTranscript.bind(this);
        this.recognition.onend = this.onRecognitionDisconnect.bind(this);
        this.recognition.onerror = this.onError.bind(this);
      }
      this.emitBrowserSupportsSpeechRecognitionChange(browserSupportsRecogniser);
    }
  }, {
    key: "subscribe",
    value: function subscribe(id, callbacks) {
      this.subscribers[id] = callbacks;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(id) {
      delete this.subscribers[id];
    }
  }, {
    key: "emitListeningChange",
    value: function emitListeningChange(listening) {
      var _this = this;
      this.listening = listening;
      Object.keys(this.subscribers).forEach(function (id) {
        var onListeningChange = _this.subscribers[id].onListeningChange;
        onListeningChange(listening);
      });
    }
  }, {
    key: "emitMicrophoneAvailabilityChange",
    value: function emitMicrophoneAvailabilityChange(isMicrophoneAvailable) {
      var _this2 = this;
      this.isMicrophoneAvailable = isMicrophoneAvailable;
      Object.keys(this.subscribers).forEach(function (id) {
        var onMicrophoneAvailabilityChange = _this2.subscribers[id].onMicrophoneAvailabilityChange;
        onMicrophoneAvailabilityChange(isMicrophoneAvailable);
      });
    }
  }, {
    key: "emitTranscriptChange",
    value: function emitTranscriptChange(interimTranscript, finalTranscript) {
      var _this3 = this;
      Object.keys(this.subscribers).forEach(function (id) {
        var onTranscriptChange = _this3.subscribers[id].onTranscriptChange;
        onTranscriptChange(interimTranscript, finalTranscript);
      });
    }
  }, {
    key: "emitClearTranscript",
    value: function emitClearTranscript() {
      var _this4 = this;
      Object.keys(this.subscribers).forEach(function (id) {
        var onClearTranscript = _this4.subscribers[id].onClearTranscript;
        onClearTranscript();
      });
    }
  }, {
    key: "emitBrowserSupportsSpeechRecognitionChange",
    value: function emitBrowserSupportsSpeechRecognitionChange(browserSupportsSpeechRecognitionChange) {
      var _this5 = this;
      Object.keys(this.subscribers).forEach(function (id) {
        var _this5$subscribers$id = _this5.subscribers[id],
          onBrowserSupportsSpeechRecognitionChange = _this5$subscribers$id.onBrowserSupportsSpeechRecognitionChange,
          onBrowserSupportsContinuousListeningChange = _this5$subscribers$id.onBrowserSupportsContinuousListeningChange;
        onBrowserSupportsSpeechRecognitionChange(browserSupportsSpeechRecognitionChange);
        onBrowserSupportsContinuousListeningChange(browserSupportsSpeechRecognitionChange);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(disconnectType) {
      if (this.recognition && this.listening) {
        switch (disconnectType) {
          case "ABORT":
            this.pauseAfterDisconnect = true;
            this.abort();
            break;
          case "RESET":
            this.pauseAfterDisconnect = false;
            this.abort();
            break;
          case "STOP":
          default:
            this.pauseAfterDisconnect = true;
            this.stop();
        }
      }
    }
  }, {
    key: "disableRecognition",
    value: function disableRecognition() {
      if (this.recognition) {
        this.recognition.onresult = function () {};
        this.recognition.onend = function () {};
        this.recognition.onerror = function () {};
        if (this.listening) {
          this.stopListening();
        }
      }
    }
  }, {
    key: "onError",
    value: function onError(event) {
      if (event && event.error && event.error === "not-allowed") {
        this.emitMicrophoneAvailabilityChange(false);
        this.disableRecognition();
      }
    }
  }, {
    key: "onRecognitionDisconnect",
    value: function onRecognitionDisconnect() {
      this.onStopListening();
      this.listening = false;
      if (this.pauseAfterDisconnect) {
        this.emitListeningChange(false);
      } else if (this.recognition) {
        if (this.recognition.continuous) {
          this.startListening({
            continuous: this.recognition.continuous
          });
        } else {
          this.emitListeningChange(false);
        }
      }
      this.pauseAfterDisconnect = false;
    }
  }, {
    key: "updateTranscript",
    value: function updateTranscript(_ref) {
      var results = _ref.results,
        resultIndex = _ref.resultIndex;
      var currentIndex = resultIndex === undefined ? results.length - 1 : resultIndex;
      this.interimTranscript = "";
      this.finalTranscript = "";
      for (var i = currentIndex; i < results.length; ++i) {
        if (results[i].isFinal && (!isAndroid() || results[i][0].confidence > 0)) {
          this.updateFinalTranscript(results[i][0].transcript);
        } else {
          this.interimTranscript = concatTranscripts(this.interimTranscript, results[i][0].transcript);
        }
      }
      var isDuplicateResult = false;
      if (this.interimTranscript === "" && this.finalTranscript !== "") {
        if (this.previousResultWasFinalOnly) {
          isDuplicateResult = true;
        }
        this.previousResultWasFinalOnly = true;
      } else {
        this.previousResultWasFinalOnly = false;
      }
      if (!isDuplicateResult) {
        this.emitTranscriptChange(this.interimTranscript, this.finalTranscript);
      }
    }
  }, {
    key: "updateFinalTranscript",
    value: function updateFinalTranscript(newFinalTranscript) {
      this.finalTranscript = concatTranscripts(this.finalTranscript, newFinalTranscript);
    }
  }, {
    key: "resetTranscript",
    value: function resetTranscript() {
      this.disconnect("RESET");
    }
  }, {
    key: "startListening",
    value: function startListening() {
      return /*#__PURE__*/_async_to_generator(function () {
        var _this6 = this;
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$continuous = _ref2.continuous,
          continuous = _ref2$continuous === void 0 ? false : _ref2$continuous,
          language = _ref2.language;
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var isContinuousChanged, isLanguageChanged;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (_this6.recognition) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                isContinuousChanged = continuous !== _this6.recognition.continuous;
                isLanguageChanged = language && language !== _this6.recognition.lang;
                if (!(isContinuousChanged || isLanguageChanged)) {
                  _context.next = 10;
                  break;
                }
                if (!_this6.listening) {
                  _context.next = 8;
                  break;
                }
                _context.next = 8;
                return _this6.stopListening();
              case 8:
                _this6.recognition.continuous = isContinuousChanged ? continuous : _this6.recognition.continuous;
                _this6.recognition.lang = isLanguageChanged ? language : _this6.recognition.lang;
              case 10:
                if (_this6.listening) {
                  _context.next = 21;
                  break;
                }
                if (!_this6.recognition.continuous) {
                  _this6.resetTranscript();
                  _this6.emitClearTranscript();
                }
                _context.prev = 12;
                _context.next = 15;
                return _this6.start();
              case 15:
                _this6.emitListeningChange(true);
                _context.next = 21;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](12);
                // DOMExceptions indicate a redundant microphone start - safe to swallow
                if (!(_context.t0 instanceof DOMException)) {
                  _this6.emitMicrophoneAvailabilityChange(false);
                }
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[12, 18]]);
        })();
      }).apply(this, arguments);
    }
  }, {
    key: "abortListening",
    value: function abortListening() {
      return /*#__PURE__*/_async_to_generator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this7 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.disconnect("ABORT");
              this.emitListeningChange(false);
              _context2.next = 4;
              return new Promise(function (resolve) {
                _this7.onStopListening = resolve;
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      })).call(this);
    }
  }, {
    key: "stopListening",
    value: function stopListening() {
      return /*#__PURE__*/_async_to_generator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this8 = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.disconnect("STOP");
              this.emitListeningChange(false);
              _context3.next = 4;
              return new Promise(function (resolve) {
                _this8.onStopListening = resolve;
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      })).call(this);
    }
  }, {
    key: "getRecognition",
    value: function getRecognition() {
      return this.recognition;
    }
  }, {
    key: "start",
    value: function start() {
      return /*#__PURE__*/_async_to_generator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.recognition && !this.listening)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return this.recognition.start();
            case 3:
              this.listening = true;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      })).call(this);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.recognition && this.listening) {
        this.recognition.stop();
        this.listening = false;
      }
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.recognition && this.listening) {
        this.recognition.abort();
        this.listening = false;
      }
    }
  }]);
  return RecognitionManager;
}();
var CLEAR_TRANSCRIPT = "CLEAR_TRANSCRIPT";
var APPEND_TRANSCRIPT = "APPEND_TRANSCRIPT";
var clearTranscript = function clearTranscript() {
  return {
    type: CLEAR_TRANSCRIPT
  };
};
var appendTranscript = function appendTranscript(interimTranscript, finalTranscript) {
  return {
    type: APPEND_TRANSCRIPT,
    payload: {
      interimTranscript: interimTranscript,
      finalTranscript: finalTranscript
    }
  };
};
var transcriptReducer = function transcriptReducer(state, action) {
  switch (action.type) {
    case CLEAR_TRANSCRIPT:
      return {
        interimTranscript: "",
        finalTranscript: ""
      };
    case APPEND_TRANSCRIPT:
      return {
        interimTranscript: action.payload.interimTranscript,
        finalTranscript: concatTranscripts(state.finalTranscript, action.payload.finalTranscript)
      };
    default:
      throw new Error();
  }
};
var _browserSupportsSpeechRecognition = !!NativeSpeechRecognition;
var _browserSupportsContinuousListening = _browserSupportsSpeechRecognition && !isAndroid();
var recognitionManager;
var useSpeechRecognition = function useSpeechRecognition() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$transcribing = _ref3.transcribing,
    transcribing = _ref3$transcribing === void 0 ? true : _ref3$transcribing,
    _ref3$clearTranscript = _ref3.clearTranscriptOnListen,
    clearTranscriptOnListen = _ref3$clearTranscript === void 0 ? true : _ref3$clearTranscript,
    _ref3$commands = _ref3.commands,
    commands = _ref3$commands === void 0 ? [] : _ref3$commands;
  var _useState = useState(SpeechRecognition.getRecognitionManager()),
    _useState2 = _slicedToArray(_useState, 1),
    recognitionManager = _useState2[0];
  var _useState3 = useState(_browserSupportsSpeechRecognition),
    _useState4 = _slicedToArray(_useState3, 2),
    browserSupportsSpeechRecognition = _useState4[0],
    setBrowserSupportsSpeechRecognition = _useState4[1];
  var _useState5 = useState(_browserSupportsContinuousListening),
    _useState6 = _slicedToArray(_useState5, 2),
    browserSupportsContinuousListening = _useState6[0],
    setBrowserSupportsContinuousListening = _useState6[1];
  var _useReducer = useReducer(transcriptReducer, {
      interimTranscript: recognitionManager.interimTranscript,
      finalTranscript: ""
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    interimTranscript = _useReducer2$.interimTranscript,
    finalTranscript = _useReducer2$.finalTranscript,
    dispatch = _useReducer2[1];
  var _useState7 = useState(recognitionManager.listening),
    _useState8 = _slicedToArray(_useState7, 2),
    listening = _useState8[0],
    setListening = _useState8[1];
  var _useState9 = useState(recognitionManager.isMicrophoneAvailable),
    _useState10 = _slicedToArray(_useState9, 2),
    isMicrophoneAvailable = _useState10[0],
    setMicrophoneAvailable = _useState10[1];
  var commandsRef = useRef(commands);
  commandsRef.current = commands;
  var dispatchClearTranscript = function dispatchClearTranscript() {
    dispatch(clearTranscript());
  };
  var resetTranscript = useCallback(function () {
    recognitionManager.resetTranscript();
    dispatchClearTranscript();
  }, [recognitionManager]);
  var testFuzzyMatch = function testFuzzyMatch(command, input, fuzzyMatchingThreshold) {
    var commandToString = typeof command === "object" ? command.toString() : command;
    var commandWithoutSpecials = commandToString.replace(/[&/\\#,+()!$~%.'":*?<>{}]/g, "").replace(/  +/g, " ").trim();
    var howSimilar = compareTwoStringsUsingDiceCoefficient(commandWithoutSpecials, input);
    if (howSimilar >= fuzzyMatchingThreshold) {
      return {
        command: command,
        commandWithoutSpecials: commandWithoutSpecials,
        howSimilar: howSimilar,
        isFuzzyMatch: true
      };
    }
    return null;
  };
  var testMatch = function testMatch(command, input) {
    var pattern = commandToRegExp(command);
    var result = pattern.exec(input);
    if (result) {
      return {
        command: command,
        parameters: result.slice(1)
      };
    }
    return null;
  };
  var matchCommands = useCallback(function (newInterimTranscript, newFinalTranscript) {
    commandsRef.current.forEach(function (_ref4) {
      var command = _ref4.command,
        callback = _ref4.callback,
        _ref4$matchInterim = _ref4.matchInterim,
        matchInterim = _ref4$matchInterim === void 0 ? false : _ref4$matchInterim,
        _ref4$isFuzzyMatch = _ref4.isFuzzyMatch,
        isFuzzyMatch = _ref4$isFuzzyMatch === void 0 ? false : _ref4$isFuzzyMatch,
        _ref4$fuzzyMatchingTh = _ref4.fuzzyMatchingThreshold,
        fuzzyMatchingThreshold = _ref4$fuzzyMatchingTh === void 0 ? 0.8 : _ref4$fuzzyMatchingTh,
        _ref4$bestMatchOnly = _ref4.bestMatchOnly,
        bestMatchOnly = _ref4$bestMatchOnly === void 0 ? false : _ref4$bestMatchOnly;
      var input = !newFinalTranscript && matchInterim ? newInterimTranscript.trim() : newFinalTranscript.trim();
      var subcommands = Array.isArray(command) ? command : [command];
      var results = subcommands.map(function (subcommand) {
        if (isFuzzyMatch) {
          return testFuzzyMatch(subcommand, input, fuzzyMatchingThreshold);
        }
        return testMatch(subcommand, input);
      }).filter(function (x) {
        return x;
      });
      if (isFuzzyMatch && bestMatchOnly && results.length >= 2) {
        results.sort(function (a, b) {
          return b.howSimilar - a.howSimilar;
        });
        var _results$ = results[0],
          _command = _results$.command,
          commandWithoutSpecials = _results$.commandWithoutSpecials,
          howSimilar = _results$.howSimilar;
        callback(commandWithoutSpecials, input, howSimilar, {
          command: _command,
          resetTranscript: resetTranscript
        });
      } else {
        results.forEach(function (result) {
          if (result.isFuzzyMatch) {
            var _command2 = result.command,
              _commandWithoutSpecials = result.commandWithoutSpecials,
              _howSimilar = result.howSimilar;
            callback(_commandWithoutSpecials, input, _howSimilar, {
              command: _command2,
              resetTranscript: resetTranscript
            });
          } else {
            var _command3 = result.command,
              parameters = result.parameters;
            callback.apply(void 0, _toConsumableArray(parameters).concat([{
              command: _command3,
              resetTranscript: resetTranscript
            }]));
          }
        });
      }
    });
  }, [resetTranscript]);
  var handleTranscriptChange = useCallback(function (newInterimTranscript, newFinalTranscript) {
    if (transcribing) {
      dispatch(appendTranscript(newInterimTranscript, newFinalTranscript));
    }
    matchCommands(newInterimTranscript, newFinalTranscript);
  }, [matchCommands, transcribing]);
  var handleClearTranscript = useCallback(function () {
    if (clearTranscriptOnListen) {
      dispatchClearTranscript();
    }
  }, [clearTranscriptOnListen]);
  useEffect(function () {
    var id = SpeechRecognition.counter;
    SpeechRecognition.counter += 1;
    var callbacks = {
      onListeningChange: setListening,
      onMicrophoneAvailabilityChange: setMicrophoneAvailable,
      onTranscriptChange: handleTranscriptChange,
      onClearTranscript: handleClearTranscript,
      onBrowserSupportsSpeechRecognitionChange: setBrowserSupportsSpeechRecognition,
      onBrowserSupportsContinuousListeningChange: setBrowserSupportsContinuousListening
    };
    recognitionManager.subscribe(id, callbacks);
    return function () {
      recognitionManager.unsubscribe(id);
    };
  }, [transcribing, clearTranscriptOnListen, recognitionManager, handleTranscriptChange, handleClearTranscript]);
  var transcript = concatTranscripts(finalTranscript, interimTranscript);
  return {
    transcript: transcript,
    interimTranscript: interimTranscript,
    finalTranscript: finalTranscript,
    listening: listening,
    isMicrophoneAvailable: isMicrophoneAvailable,
    resetTranscript: resetTranscript,
    browserSupportsSpeechRecognition: browserSupportsSpeechRecognition,
    browserSupportsContinuousListening: browserSupportsContinuousListening
  };
};
var SpeechRecognition = {
  counter: 0,
  applyPolyfill: function applyPolyfill(PolyfillSpeechRecognition) {
    if (recognitionManager) {
      recognitionManager.setSpeechRecognition(PolyfillSpeechRecognition);
    } else {
      recognitionManager = new RecognitionManager(PolyfillSpeechRecognition);
    }
    var browserSupportsPolyfill = !!PolyfillSpeechRecognition && browserSupportsPolyfills();
    _browserSupportsSpeechRecognition = browserSupportsPolyfill;
    _browserSupportsContinuousListening = browserSupportsPolyfill;
  },
  removePolyfill: function removePolyfill() {
    if (recognitionManager) {
      recognitionManager.setSpeechRecognition(NativeSpeechRecognition);
    } else {
      recognitionManager = new RecognitionManager(NativeSpeechRecognition);
    }
    _browserSupportsSpeechRecognition = !!NativeSpeechRecognition;
    _browserSupportsContinuousListening = _browserSupportsSpeechRecognition && !isAndroid();
  },
  getRecognitionManager: function getRecognitionManager() {
    if (!recognitionManager) {
      recognitionManager = new RecognitionManager(NativeSpeechRecognition);
    }
    return recognitionManager;
  },
  getRecognition: function getRecognition() {
    var recognitionManager = SpeechRecognition.getRecognitionManager();
    return recognitionManager.getRecognition();
  },
  startListening: function startListening() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      continuous = _ref5.continuous,
      language = _ref5.language;
    return /*#__PURE__*/_async_to_generator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var recognitionManager;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            recognitionManager = SpeechRecognition.getRecognitionManager();
            _context5.next = 3;
            return recognitionManager.startListening({
              continuous: continuous,
              language: language
            });
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  stopListening: function stopListening() {
    return /*#__PURE__*/_async_to_generator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var recognitionManager;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            recognitionManager = SpeechRecognition.getRecognitionManager();
            _context6.next = 3;
            return recognitionManager.stopListening();
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  abortListening: function abortListening() {
    return /*#__PURE__*/_async_to_generator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var recognitionManager;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            recognitionManager = SpeechRecognition.getRecognitionManager();
            _context7.next = 3;
            return recognitionManager.abortListening();
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  browserSupportsSpeechRecognition: function browserSupportsSpeechRecognition() {
    return _browserSupportsSpeechRecognition;
  },
  browserSupportsContinuousListening: function browserSupportsContinuousListening() {
    return _browserSupportsContinuousListening;
  }
};
export { SpeechRecognition as default, useSpeechRecognition };